// Neutral module: the root layout (a server component) needs the script, and
// runtime values must not be imported from a 'use client' module there.
export const THEME_STORAGE_KEY = 'halo-theme'

/**
 * Runs before first paint, inlined in <head>. Without it the page paints in
 * one theme, hydrates, and flips. try/catch because Safari's private mode
 * throws on localStorage, and a theme preference is not worth a blank page.
 */
export const THEME_SCRIPT = `(function(){try{
var p=localStorage.getItem('${THEME_STORAGE_KEY}');
var d=p==='dark'||(p!=='light'&&matchMedia('(prefers-color-scheme: dark)').matches);
document.documentElement.classList.toggle('dark',d);
document.documentElement.style.colorScheme=d?'dark':'light';
}catch(e){}})()`
